import { useLoading } from '@contexts/LoadingContext';
import React, {
  JSX,
  PropsWithChildren,
  useEffect,
  useRef,
  useState,
} from 'react';

function SuspenseWrapper({
  children,
  id,
}: {
  id?: string;
  children: React.JSX.Element | null;
}) {
  const { isLoaded, setLoaded } = useLoading();

  const [isMounted, setMounted] = useState(false);

  useEffect(() => {
    if (!isMounted) {
      setMounted(true);
    }
    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (isMounted && id) {
      setLoaded(id);
    }
  }, [isMounted, id]);

  return children;
}

export default SuspenseWrapper;
